import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import Welcome from './Welcome';
import Navigation from './Navigation';
import TicketPage from '../TicketPage/TicketPage';
import Single from '../TicketPage/Single';
import NotificationPage from '../NotificationPage/NotificationPage';
import StatsPage from '../StatsPage/StatsPage';
import SettingsPage from '../SettingsPage/SettingsPage';
import ProfilePage from '../ProfilePage/ProfilePage';
import UserPage from '../UserPage/UserPage';

const Dashboard = ({ className }) => {
    const [hasActiveLicense, setActiveLicense] = useState(null);

    const hasActiveLicenseState = useSelector(state => {
        return !!state.license.active.ID || false;
    });

    useEffect(() => {
        setActiveLicense(hasActiveLicenseState);
    }, [hasActiveLicenseState]);

    return (
        <div className={className}>
            {hasActiveLicense ? (
                <div className="Dashboard">
                    <div className="Dashboard__ContentWrapper">
                        <Switch>
                            <Route
                                exact
                                path="/dashboard"
                                component={TicketPage}
                            />
                            <Route
                                exact
                                path="/notifications"
                                component={NotificationPage}
                            />
                            <Route exact path="/stats" component={StatsPage} />
                            <Route
                                exact
                                path="/settings"
                                component={SettingsPage}
                            />
                            <Route
                                exact
                                path="/profile"
                                component={ProfilePage}
                            />
                            <Route exact path="/user" component={UserPage} />
                            <Route path="/ticket/:id" component={Single} />
                            <Redirect to="/dashboard" />
                        </Switch>
                        <Navigation />
                    </div>
                </div>
            ) : (
                <Welcome />
            )}
        </div>
    );
};

Dashboard.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(Dashboard)`
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    height: 100%;
    width: 100%;

    .Dashboard {
        display: flex;
        flex-flow: column wrap;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    .Dashboard__ContentWrapper {
        width: 100%;
        height: calc(100vh - 70px);
    }
`;
